export class Badge {
    tag: string = ""
    group?: number
    bg?: string

    constructor(some?: Partial<Badge>) {
        Object.assign(this, some);
    }
}
